/**
 * Secure refresh token storage utility
 * Only stores the refresh token - access token is kept in memory only
 * Uses sessionStorage by default (cleared on tab close)
 */

const REFRESH_TOKEN_KEY = 'codezo_refresh_token';

/**
 * Store refresh token securely
 * @param refreshToken - The refresh token to store
 */
export function storeRefreshToken(refreshToken: string): void {
	try {
		sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
	} catch {
		// Error handled by mutation onError
	}
}

/**
 * Retrieve stored refresh token
 * @returns The stored refresh token or null if not found
 */
export function getStoredRefreshToken(): string | null {
	try {
		return sessionStorage.getItem(REFRESH_TOKEN_KEY);
	} catch {
		// Error handled by mutation onError
		return null;
	}
}

/**
 * Clear stored refresh token
 */
export function clearRefreshToken(): void {
	try {
		sessionStorage.removeItem(REFRESH_TOKEN_KEY);
	} catch {
		// Error handled by mutation onError
	}
}

/**
 * Check if we have a stored refresh token
 * @returns True if a refresh token is stored
 */
export function hasStoredRefreshToken(): boolean {
	return !!getStoredRefreshToken();
}
